export default "__VITE_ASSET__B_D$CCgh__"